import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  padding-left: 24px;
  padding-right: 24px;
`;

export const StyledSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 16px;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  width: 100%;

  & > h1 {
    margin-bottom: 0;
    margin-right: auto;
  }

  & > select {
    width: 250px;
  }
`;
